module.exports = __webpack_public_path__ + "static/media/BussinessRules.e4a66695.svg";